<div *ngIf="formType === QueryFormType.UKMORTGAGE">
  <div class="row">
    <div class="col">
      <h2>Thank you!</h2>
      <p>Your form has been submitted.</p>
      <p>Your reference is <b>{{successModel.urlRefNum}}</b></p>
      <p>We will be in contact with you soon.</p>
      <p>If you have any questions you are welcome to contact your Private Banker to discuss.</p>
    </div>
    <div class="col">
      <img alt="Mortgage success" class="w-100" src="../../../../assets/images/mortgage-success.png" title="Mortgage"/>
    </div>
  </div>
</div>
<div *ngIf="formType !== QueryFormType.UKMORTGAGE">
  <div *ngIf="isLoading" class="row">
    <ui-full-page-loader [loading]="isLoading"
                         [message]="'Opting out of AXA travel insurance. Please don\'t refresh the browser.'"></ui-full-page-loader>
  </div>

  <div *ngIf="successModel.refKey !== null" class="onb-form-success">
    <div *ngIf="optOutSuccess" class="row">
      <div class="col-12 upload-success">
        <ui-alerts [alertName]="'success'" [message]="'Axa opt out successful'"></ui-alerts>
      </div>
    </div>
    <div class="row">
      <div *ngIf="successModel.imageTitle !== null" class="col-md-3 card-image d-none d-md-block">
        <img alt="Voyage card image" src="../../../../assets/images/{{successModel.imageTitle}}.png" title="Voyage"/>
        <p class="lead text-info-emphasis">{{successModel.urlTitle}}</p>
        <!-- <div class="feedback">
          <ui-icon [name]="'icon-investec-feedback'"  [size]="'72'"></ui-icon>
          <p class="text-sky"><b>Share your account opening experience</b></p>
        </div>       -->
      </div>
      <div class="col-sm-12 col-md-9">
        <div class="d-flex align-items-center">
          <div class="icon-position">
            <ui-icon [color]="'success'" [name]="'interface-indicator-success'" [size]="'72'"></ui-icon>
          </div>
          <h2 class="h5">Thank you! Your application has been submitted</h2>
        </div>

        <h6>Your reference number is <b data-di-mask>{{successModel.urlRefNum}}</b></h6>
        <p>We'll send an email confirming your application. <br>Your reference number and our contact details will be
          included in the confirmation email.</p>

        <h5 class="title">What happens next</h5>
        <div class="row">
          <div class="col-md-6">
            <ui-icon [name]="'miscellaneous-checklist'" [size]="'72'"></ui-icon>
            <h6><b>We will check your details</b></h6>
            <p>We will check that we have everything needed to open your account and will be in touch should we require
              any documentation to complete your application.</p>
          </div>
          <div class="col-md-6">
            <ui-icon [name]="'online-banking'" [size]="'72'"></ui-icon>
            <h6><b>Use your new account online</b></h6>
            <p>Once your application has been successfully processed you will receive an email with all the information
              you need to use your new account on our app or online.</p>
          </div>
        </div>

        <h5>Contact us</h5>
        <p>Please quote your reference number when contacting us about your application</p>

        <div class="row">
          <div class="col-1">
            <ui-icon [name]="'help-and-support-call-default'" [size]="'24'"></ui-icon>
          </div>
          <div class="col-11">
            <p>
              <span
                  *ngIf="successModel.refKey.toLocaleUpperCase() === 'VOY'"><b>0330 123 4512 (+ 44 207 597 4050)</b></span>
              <span
                  *ngIf="successModel.refKey.toLocaleUpperCase() === 'PBA'"><b>0330 123 1966 (+ 44 207 597 4044)</b></span>
              <span
                  *ngIf="successModel.refKey.toLocaleUpperCase() === 'CAA'"><b>0330 123 3655 (+ 44 207 597 4131)</b></span>
              We're available 24/7/365
            </p>
          </div>
        </div>

        <div class="row">
          <div class="col-1">
            <ui-icon [name]="'help-and-support-email'" [size]="'24'"></ui-icon>
          </div>
          <div class="col-6">
            <a href="mailto:banking&#64;investec.co.uk">banking&#64;investec.co.uk</a>
          </div>
        </div>

        <hr class="hr-spacing">

        <!-- AXA opt out form-->
        <div *ngIf="successModel.refKey === 'VOY'" class="row">
          <div class="d-none d-sm-block col-sm-2">
            <img alt="Axa logo" class="axa-logo" height="auto" src="../../../assets/images/axa.png" title="Axa"
                 width="100%"/>
          </div>
          <div class="col-12 col-sm-10">

            <h6>Opt out of automatic renewal of the AXA travel insurance</h6>
            <p>If you’d like to opt out of automatically renewing the AXA travel insurance, please read the explanatory
              document <a
                  href="https://images.investec.com/campaign/AXA%20Travel%20Insurance%20automatic%20opt-out%20information.pdf"
                  target="_blank" title="AXA documentation">we provided at the start of the application process.</a></p>
            <p>In summary:</p>
            <ul>
              <li>We don’t offer the Voyage account without the associated benefits, including the AXA travel insurance,
                which means we’ll also close your account.
              </li>
              <li>If you choose not to auto-renew the AXA travel insurance, it will end when your current cover period
                finishes.
              </li>
            </ul>

            <form #axaOptOutForm="ngForm" class="optout-form-container">
              <div class="form-group row">
                <div class="col-12">
                  <ui-single-checkbox (returnEvt)="toggleOptOut($event)" [id]="'otpOutCheckbox'"
                                      [model]="axaOtpOutValue">
                    <span class="small">I understand that by opting out of auto-renewing the AXA travel insurance, my Voyage account will be closed when the current AXA travel insurance coverage period ends and my AXA travel insurance will also cease at this time</span>
                  </ui-single-checkbox>
                  <div class="row">
                    <div class="col-12 col-sm-6 btn-container">
                      <ui-button (click)="handleOtpOutSubmit()"
                                 [block]="true"
                                 [btnClass]="'primary'"
                                 [disabled]="!axaOtpOutValue">
                        Opt out of automatic renewal
                      </ui-button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <hr>
    </div>
  </div>
</div>
